export default {"src":"/_next/static/media/carbon-projects.a553c8f3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};